<template>
  <div class="l-row--t64 l-row--t128l module pic-set">
		<div class="g-row" :class="data.target.layout == 1">
			<div :class="{
				'g-col--9 g-col--5s': data.target.layout == 0,
				'g-col--6 g-col--5s': data.target.layout == 1,
				'g-col--half g-col--5s': data.target.layout == 2,
				's--none-mo': !checkDisplay(data.target.items[0].src)
			}">
				<div class="c-pic i--item-1">
					<Picture v-show="checkDisplay(data.target.items[0].src)" :coverSrc="data.target.items[0].coverSrc" :parallax="data.target.items[0].parallax == 0 ? false : true" :src="data.target.items[0].src" :from="data.target.items[0].from" :embedType="data.target.items[0].embedType" :ratio="data.target.items[0].ratio" />
					<div class="c-pic__desc">
						<div class="t-h--13 t-h--11s">
							<span class="t--fak c-pic__desc--info" v-html="data.target.items[0].caption"></span>
						</div>
					</div>
				</div>
			</div>
			<div :class="{
				'g-col--6 g-col--5s': data.target.layout == 0,
				'g-col--9 g-col--5s':data.target.layout ==1,
				'g-col--half g-col--5s': data.target.layout == 2,
				's--none-mo': !checkDisplay(data.target.items[1].src),
				'l-mdl--64s': checkDisplay(data.target.items[0].src)
			}">
				<div class="c-pic i--item-2">
					<Picture v-show="checkDisplay(data.target.items[1].src)" :coverSrc="data.target.items[1].coverSrc" :parallax="data.target.items[1].parallax == 0 ? false : true" :src="data.target.items[1].src" :from="data.target.items[1].from" :embedType="data.target.items[1].embedType" :ratio="data.target.items[1].ratio" />
					<div class="c-pic__desc">
						<div class="t-h--13 t-h--11s">
							<span class="t--fak c-pic__desc--info" v-html="data.target.items[1].caption"></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as $ from "fxdom";
import * as _ from "fxjs";
import { computed, onMounted, ref, reactive, watch, useStore } from "@/helper/vue.js";
import Picture from "@/parts/picture/PictureView.vue";
import { useRoute } from 'vue-router';

export default {
  props: ["idx", "bindRoot"],
	components: {
		Picture
	},
  setup(props) {
    const { state, get, commit } = useStore();
		const self = ref();
		const route = useRoute();
		const data = reactive({
			target: computed(() => get["from"](`${props.bindRoot}.modules.${props.idx}`)),
		});

		const checkDisplay = (src) => {
			return route.name == "project" && src == "" ? false : true
		}

    return {
			self,
			data,
			checkDisplay
    };
  },
};
</script>

<style scoped lang="scss">
</style>